var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEmobility(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1597",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#DED6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8 133.209H87.4572H76.5144C47.1994 133.209 22.4292 110.213 21.6144 80.9165C20.7815 50.515 45.2542 23.5756 75.3918 21.5999C112 19.2001 135.2 45.5999 138.604 71.6528C139.755 80.4588 135.29 88.8 126.4 88.8H118.994",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 128H94.3999V139.2H104V128Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.026 124.8H123.2V142.4H108.026C105.81 142.4 104 140.597 104 138.391V128.832C104 126.626 105.81 124.824 108.026 124.824V124.8Z",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 129.6H131.988",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.8 136.608H131.988",
    stroke: "#5D38E5",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.747 69.2218L98.1971 58.2246C97.7643 57.7262 97.1366 57.4399 96.4765 57.4399H74.4392C73.9231 57.4399 73.4222 57.6151 73.0187 57.9369L59.1905 68.9607C58.974 69.1333 58.7279 69.265 58.4642 69.3493L39.9844 75.2604C39.0405 75.5623 38.3999 76.4398 38.3999 77.4308V86.5793C38.3999 87.8379 39.4202 88.8581 40.6787 88.8581H48.5271C49.2274 88.8581 49.7683 89.4669 49.7683 90.1672V90.1672C49.7683 95.9511 53.8402 100.64 58.8631 100.64C63.8859 100.64 67.9578 95.9511 67.9578 90.1672V90.1672C67.9578 89.4669 68.4987 88.8581 69.199 88.8581H89.4534C90.1537 88.8581 90.6946 89.4669 90.6946 90.1672V90.1672C90.6946 95.9511 94.7665 100.64 99.7894 100.64C104.812 100.64 108.884 95.9511 108.884 90.1672V90.1672C108.884 89.4669 109.425 88.8581 110.125 88.8581H116.807H120",
    stroke: "#5D38E5",
    strokeWidth: 6.4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmobility);
export default __webpack_public_path__ + "static/media/icon_emobility.852a8aca1c08b42a9b1be6fbd26a896b.svg";
export { ForwardRef as ReactComponent };